<div>

  <!-- Pre-Trip Damages -->
  <div
    class='dmageDetails'
    *ngIf='moreDetails.preDamageLists && moreDetails.preDamageLists.length > 0'
  >
    <h3>Pre-Trip</h3>
    {{ moreDetails.timeStampPre }}

    <!-- List -->
    <div class='margin-b-15' *ngFor='let more of moreDetails.preDamageLists'>
      <div>
        <hr />
        <h4>{{ getCategoryNameTranslationTag(moreDetails) + '.' + more.title | translate | titlecase }}</h4>
        <p [ngStyle]='more.style'>
					<span *ngFor='let comment of more.content; let i = index'>
						{{ getPredefinedCommentTranslationTag(moreDetails) + '.' + comment | translate | titlecase }}
            <span *ngIf='i < more.content.length - 1'>, </span>
					</span>
        </p>

        <ul class="textFieldData" *ngIf="more.textFieldData">
          <li *ngFor="let fieldData of more.textFieldData | keyvalue">
            <strong>{{ 'PREDEFINED_COMMENTS_TEXT.' + fieldData.key | translate }}:</strong>
            {{ fieldData.value }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Comment -->
    <div *ngIf="moreDetails.preTripComment">
      <hr />
      <h4>{{ 'GENERIC.additionalComments' | translate }}</h4>
      <p>{{ moreDetails.preTripComment }}</p>
    </div>

    <!-- Download Button -->
    <button
      *ngIf='moreDetails.preDamageLists && moreDetails.preDamageLists.length > 0'
      mat-raised-button
      (click)='downloadZipFile(moreDetails.zipPathPre)'
    >
      {{ 'DVCR.downloadImage' | translate }}
    </button>
  </div>

  <!-- Post-Trip Damage -->
  <div
    class='dmageDetails'
    *ngIf='!moreDetails.same && moreDetails.postDamageLists && moreDetails.postDamageLists.length > 0'
  >
    <h3>Post-Trip</h3>
    {{ moreDetails.timeStampPost }}

    <!-- List -->
    <div class='margin-b-15' *ngFor='let more of moreDetails.postDamageLists'>
      <div>
        <hr />
        <h4>{{ getCategoryNameTranslationTag(moreDetails) + '.' + more.title | translate | titlecase }}</h4>
        <p [ngStyle]='more.style'>
					<span *ngFor='let comment of more.content; let i = index'>
						{{ getPredefinedCommentTranslationTag(moreDetails) + '.' + comment | translate | titlecase }}
            <span *ngIf='i < more.content.length - 1'>, </span>
					</span>
        </p>
        <ul class="textFieldData" *ngIf="more.textFieldData">
          <li *ngFor="let fieldData of more.textFieldData | keyvalue">
            <strong>{{ 'PREDEFINED_COMMENTS_TEXT.' + fieldData.key | translate }}:</strong>
            {{ fieldData.value }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Comment -->
    <div *ngIf="moreDetails.postTripComment">
      <hr />
      <h4>{{ 'GENERIC.additionalComments' | translate }}</h4>
      <p>{{ moreDetails.postTripComment }}</p>
    </div>

    <!-- Download Button -->
    <button
      *ngIf='moreDetails.postDamageLists && moreDetails.postDamageLists.length > 0'
      mat-raised-button
      (click)='downloadZipFile(moreDetails.zipPathPost)'
    >
      {{ 'DVCR.downloadImage' | translate }}
    </button>
  </div>

  <!-- Floating DVIR Damage -->
  <div
    class='dmageDetails'
    *ngIf='!moreDetails.same && moreDetails.floatingDvirDamageLists?.length > 0'
  >
    <h3>DVIR</h3>
    {{ moreDetails.timeStampFloatingDvir }}

    <!-- List -->
    <div class='margin-b-15' *ngFor='let more of moreDetails.floatingDvirDamageLists'>
      <div>
        <hr />
        <h4>{{ getCategoryNameTranslationTag(moreDetails) + '.' + more.title | translate | titlecase }}</h4>
        <p [ngStyle]='more.style'>
					<span *ngFor='let comment of more.content; let i = index'>
						{{ getPredefinedCommentTranslationTag(moreDetails) + '.' + comment | translate | titlecase }}
            <span *ngIf='i < more.content.length - 1'>, </span>
					</span>
        </p>
        <ul class="textFieldData" *ngIf="more.textFieldData">
          <li *ngFor="let fieldData of more.textFieldData | keyvalue">
            <strong>{{ 'PREDEFINED_COMMENTS_TEXT.' + fieldData.key | translate }}:</strong>
            {{ fieldData.value }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Comment -->
    <div *ngIf="moreDetails.floatingDvirComment">
      <hr />
      <h4>{{ 'GENERIC.additionalComments' | translate }}</h4>
      <p>{{ moreDetails.floatingDvirComment }}</p>
    </div>

    <!-- Download Button -->
    <button
      *ngIf='moreDetails.floatingDvirDamageLists?.length > 0'
      mat-raised-button
      (click)='downloadZipFile(moreDetails.zipPathFloatingDvir)'
    >
      {{ 'DVCR.downloadImage' | translate }}
    </button>
  </div>

  <!-- No Damages, just comments -->
  <div *ngIf="hasStandaloneComments">
    <h4>{{ 'GENERIC.additionalComments' | translate }}</h4>
    <p *ngIf="moreDetails.preTripComment">{{ moreDetails.preTripComment }}</p>
    <p *ngIf="moreDetails.postTripComment">{{ moreDetails.postTripComment }}</p>
  </div>
</div>
